import React, { useCallback, useMemo } from "react";

import { UseCreateFormReturn } from "../../../../../../../../hooks/useCreateForm";
import { Schema } from "../../../../../../../../redux/constants/OrdersPage/order";
import { Tab } from "../../types/Tab";
import { CheckBoxWithText } from "../../../../../../../../components/common";

interface RateIncludePickupCostProps {
	form: UseCreateFormReturn<Schema>;
	disabled: boolean;
	tab: Tab;
}

const ManualTransfer: React.FC<RateIncludePickupCostProps> = ({
	form,
	disabled,
	tab,
}) => {
	const manualTransfer = useMemo(
		() => !tab?.form?.manualTransfer,
		[tab?.form?.manualTransfer],
	);

	const setManualTransfer = useCallback(
		(value: boolean) => {
			form.setValue("manualTransfer", Boolean(value));
		},
		[form],
	);

	const onChange = useCallback(
		(value: boolean) => {
			setManualTransfer(!value);
		},
		[setManualTransfer],
	);

	return (
		<CheckBoxWithText
			disabled={disabled}
			value={Boolean(manualTransfer)}
			onChange={onChange}
			title="settings.interface.colors.groups.transfer"
		/>
	);
};

export default ManualTransfer;
